import { j as n } from "../../../jsx-runtime-B6kdoens.js";
import { c as i } from "../../../index-CROKJrb5.js";
import { c as a, f as c } from "../../../create-component-CBAeEoQ6.js";
import { Link as u } from "../../Link/index.js";
import { useFooterStateAtoms as f } from "../FooterState/index.js";
import { u as p } from "../../../react-B_GApDuV.js";
const l = i({
  base: "cur-no-underline hover:cur-underline",
  variants: {
    mode: {
      dark: "cur-text-inverse hover:cur-text-inverse",
      light: null
    }
  }
}), F = a(
  "FooterLink",
  c(
    ({ children: o, className: e, ...r }, t) => {
      const { modeAtom: s } = f(), m = p(s);
      return /* @__PURE__ */ n.jsx(
        u,
        {
          ref: t,
          size: "cta",
          className: l({ mode: m, className: e }),
          ...r,
          children: o
        }
      );
    }
  )
);
export {
  F as FooterLink
};
//# sourceMappingURL=index.js.map
